import {
    GET_MENU_USER_COMPANY
} from "@/shared/components/menu_user_company/store/types/types.js";

const getters = {
    [GET_MENU_USER_COMPANY]: state => state.menu_user_company, 
};

export default getters;